import * as moment from 'moment'
import ReprocessService from "../../services/reprocess/ReprocessService"
export default {
    data: () => ({
        rules: {
            required: value => !!value || 'El campo es requerido'
        },
        initialDate: '',
        finalDate: '',
        minDate: '',
        menuInitialDate: false,
        menuFinalDate: false,
        reprocessInit: false,
        isResponse: false,
        numberProcessed: 0,
        numberErrors: 0,
        dataErrors: []
    }),

    computed: {
    },

    watch: {
    },

    methods: {
        changeInitialDate() {
            let initialDate = moment(this.initialDate).format('YYYY-MM-DD')
            this.minDate = initialDate
            if (this.finalDate !== null & this.finalDate !== undefined && this.finalDate !== '') {
                if (!moment(this.finalDate).isSameOrAfter(initialDate)) {
                    this.finalDate = this.minDate
                }
            } else {
                this.finalDate = this.minDate
            }
        },
        async reprocessPendingsInit() {
            if (this.initialDate === null || this.initialDate === undefined || this.initialDate === '' || this.finalDate === null || this.finalDate === undefined || this.finalDate === '') {
                this.$notify({
                    group: 'app',
                    type: 'error',
                    text: 'Debe seleccionar un rango de fecha valido'
                })
                return
            }

            this.reprocessInit = true;
            this.isResponse = false;
            this.dataErrors = [];

            await ReprocessService.updateOrderReprocess(this.initialDate, this.finalDate)
                .then(result => {
                    this.numberErrors = result.data.NumberErrors;
                    this.numberProcessed = result.data.NumberProcessed;
                    this.dataErrors = result.data.ErrorList;
                    this.isResponse = true;
                    this.reprocessInit = false;
                    return result;
                })
                .catch(erro => {
                    console.log('Error: ', erro)
                });
        },
    }
}